import { publicClient, privateClient } from './client';
import { Organization } from './Organization';

const transactionsOrganization = (pub: boolean) => new Organization(pub ? publicClient : privateClient);
export default transactionsOrganization;
